import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Whether the box is ticked. A server-rendered mount seeds it with the `true` the URL carries; a
   * Vue host binds a boolean. Any other value reads as unticked.
   *
   * @type {Boolean|String}
   */
  modelValue: {
    type: [Boolean, String],
    default: undefined,
  },
  /** The filter's label: the chip's text, and the standalone activator's placeholder. Per mount, so a prop. */
  label: {
    type: String,
    required: true,
  },
  /**
   * The checkbox row's wording, naming what a tick narrows the results to ("Show only providers
   * accepting new patients"). Falls back to `label`. Per mount, so a prop.
   */
  optionLabel: {
    type: String,
    default: undefined,
  },
  /**
   * The activator's text while the box is ticked ("New Patients"). Falls back to `optionLabel`.
   * Per mount, so a prop.
   */
  selectedLabel: {
    type: String,
    default: undefined,
  },
  /** Help text for the option, shown in a tooltip beside it. Nothing renders while absent. */
  helpText: {
    type: String,
    default: undefined,
  },
  /**
   * Sets a `data-testid` attribute on the checkbox. Pass a catalog value from the feature-specific
   * mount (see `app/frontend/src/test-ids.json`); absent, the checkbox carries none.
   */
  optionTestId: {
    type: String,
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: undefined,
  },
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /** @type {Boolean|String} */
  hidePointer: booleanAttribute(),
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  location: {
    type: String,
    default: undefined,
  },
  /** @type {Boolean|String} */
  nonClearable: booleanAttribute(),
});
